import React, { createContext, useContext, useState } from 'react'
import { useStkCharts } from './StkChartsProvider'

// Using 'FAS' acronym for consistency with the API.
// FAS (Find And Save) is pre-launch name for Surprise Savings
// SIFI (Set It and Forget It) is the pre-launch name for Recurring transfers

export interface ICrunchNumbersViewState {
  sifiChecked: boolean
  rupChecked: boolean
  fasChecked: boolean
  enrolledInBoosters: boolean
  enrolledRecurringTransfers: boolean
  enrolledRoundUps: boolean
  enrolledSurpriseSavings: boolean
  hasUserInteracted: boolean
}

export interface StkCrunchNumbersProps extends ICrunchNumbersViewState {
  updateView: (updated: Partial<ICrunchNumbersViewState>) => void
}

export const CrunchNumbersViewContext = createContext({} as any)

export const CrunchTheNumbersViewProvider: React.FC = ({ children }) => {
  const { potential } = useStkCharts()
  // check if enrolled in recurringTransfers
  const recurringTransferBooster = potential?.averageData.find(
    ({ depositType }) => depositType === 'SIFI',
  )

  const enrolledRecurringTransfers =
    recurringTransferBooster?.enrolledFlag || false

  // check if enrolled in roundUps
  const roundUpsBooster = potential?.averageData.find(
    ({ depositType }) => depositType === 'RUP',
  )

  const enrolledRoundUps = roundUpsBooster?.enrolledFlag || false

  // check if enrolled in surpriseSavings
  const surpriseSavingsBooster = potential?.averageData.find(
    ({ depositType }) => depositType === 'FAS',
  )

  const enrolledSurpriseSavings = surpriseSavingsBooster?.enrolledFlag || false

  const enrolledInBoosters =
    enrolledRecurringTransfers || enrolledRoundUps || enrolledSurpriseSavings
  const [state, setState] = useState<ICrunchNumbersViewState>({
    sifiChecked: enrolledRecurringTransfers,
    rupChecked: enrolledRoundUps,
    fasChecked: enrolledSurpriseSavings,
    enrolledInBoosters,
    enrolledRecurringTransfers,
    enrolledRoundUps,
    enrolledSurpriseSavings,
    hasUserInteracted: false,
  })

  const updateView = (updated: Partial<ICrunchNumbersViewState>): void => {
    setState(prev => ({ ...prev, ...updated }))
  }

  return (
    <CrunchNumbersViewContext.Provider
      value={{
        ...state,
        updateView,
      }}
    >
      {children}
    </CrunchNumbersViewContext.Provider>
  )
}

export const useCrunchNumbersView = (): StkCrunchNumbersProps =>
  useContext(CrunchNumbersViewContext)
